import request from '@/utils/request'

/* 酒店库存管理 */
export function getStock(data) {
  return request({
    url: 'alp/hotel_stock/list',
    data
  })
}

/* 酒店价格获取 */
export function getPrice(data) {
  return request({
    url: 'alp/hotel_price/list',
    data
  })
}

/* 酒店上下线 */
export function UpAndDownLine(data) {
  return request({
    url: 'alp/hotel_price/online',
    data
  })
}

/* 酒店价格修改 */
export function priceEdit(data) {
  return request({
    url: 'alp/hotel_price/edit',
    data
  })
}

/* 酒店价格添加 */
export function priceAdd(data) {
  return request({
    url: 'alp/hotel_price/add',
    data
  })
}

/* 酒店单个价格修改 */
export function setStock(data) {
  return request({
    url: 'alp/hotel_stock/updatedStock',
    data
  })
}

